export default __webpack_public_path__ + "static/media/rpt-zee-full-logo.25128607.png";